import { Spin } from 'antd'
import { useSelector } from 'react-redux'
import React, { useMemo } from 'react'

import { ApplicationState } from 'src/store'
import { AssignTree } from 'src/types'
import { PropsTreeSelected } from 'src/views/Management/Administration/views/tree'

import { RenderNodes } from './RenderNodes'

type Props = {
  addNode?: (node: AssignTree) => void
  setTreeSelected?: (treeSelected: PropsTreeSelected) => void
  valuedNodes?: Pick<AssignTree, 'assign_tree_id' | 'color' | 'disabled'>[]
}

export function Tree({ addNode, setTreeSelected, valuedNodes }: Props) {
  const { tree } = useSelector((state: ApplicationState) => ({
    tree: state.tree
  }))

  const trees = useMemo(() => {
    const treeCopy = JSON.parse(JSON.stringify(tree.list)) // deep copy
    if (!valuedNodes?.length) {
      return treeCopy
    }

    function treeUpdate(acc: AssignTree[], cur: AssignTree): AssignTree[] {
      const foundNode = valuedNodes.find(
        node => `${node.assign_tree_id}` === `${cur.assign_tree_id}`
      )

      if (foundNode) {
        cur.disabled = foundNode.disabled
        cur.color = foundNode.color
      }

      return [
        ...acc,
        {
          ...cur,
          childrens: cur.childrens?.reduce(treeUpdate, [])
        }
      ]
    }

    return treeCopy.reduce(treeUpdate, [])
  }, [valuedNodes, tree])

  if (tree.loading) {
    return <Spin />
  }

  return (
    <RenderNodes
      addNode={addNode}
      nodes={trees}
      setTreeSelected={setTreeSelected}
    />
  )
}
